// @flow
import { CommonActions } from '@react-navigation/native';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { tripica } from '../../api';
import HandleErrorService from '../../lib/handleError';
import I18n from '../../lib/i18n';
import Navigation from '../../lib/navigation';
import { setLoading } from '../LoadingStatus/actions';
import { fetchRioFailure, fetchRioSuccess } from './actions';
import type { RioAction } from './actions';
import WizzeeLog from '../../lib/wizzeeLog';

export function* getRioSaga(action: RioAction): Generator<*, *, *> {
  if (action.type !== 'FETCH_RIO_REQUEST') return; // for flow
  try {
    yield put(setLoading('fetchRio', true));
    const response = yield call(
      [tripica, 'getRio'],
      action.payload.subscription && action.payload.subscription.line.number
    );
    if (!response) {
      throw new Error('No response');
    }
    yield put(fetchRioSuccess(response));
    yield call(Navigation.dispatch, CommonActions.navigate({ name: 'getRioNumber', params: { rio: response.rio } }));
  } catch (error) {
    WizzeeLog.warn('[saga] getRio', error);
    yield put(fetchRioFailure());
    HandleErrorService.showToastError(I18n.t('error.serverError'));
  } finally {
    yield put(setLoading('fetchRio', false));
  }
}

export default function*(): Generator<*, *, *> {
  yield all([takeEvery('FETCH_RIO_REQUEST', getRioSaga)]);
}
